import { types, SnapshotIn } from 'mobx-state-tree'
import { Side } from 'src/constants/sides'
import { ElementEdge } from 'src/api/models/Elements'
import { generateType } from 'src/api/models/utils/generateNodeType'
import { enclosureConnection } from 'src/constants/typenames'
import { AdapterEdge } from './Adapter'
import { Cover, CoverEdge, CoverPlate } from './Cover'
import { coverEdge as coverEdgeDefault } from 'src/constants/defaultValues'
import { IEnclosureConnection } from './types'

interface PlateEdgeTranslation {
  position?: [number, number, number]
  matrixAutoUpdate?: boolean
  matrix?: [number, number, number, number, number, number, number, number, number, number, number, number, number, number, number, number] // prettier-ignore
  quaternion?: [number, number, number, number]
}

/*
 * adapterHeadPositions
 *  - coverPlatescrewholes
 *  - screws
 *
 */

export const EnclosureConnection: IEnclosureConnection = generateType(enclosureConnection)
  .props({
    adapterEdges: types.optional(types.array(types.late(AdapterEdge)), [{} as any]),
    coverEdges: types.optional(types.array(types.late(CoverEdge)), [coverEdgeDefault] as any)
  })
  .actions(self => ({
    addElement(element: SnapshotIn<ReturnType<typeof ElementEdge>>, side: Side) {
      self.coverEdges.forEach(coverEdge =>
        coverEdge.node.plates.edges
          .filter(plateEdge => plateEdge.properties.side === side)
          .forEach(plateEdge => plateEdge.node.elements.edges.push(element))
      )
    }
  }))

export { Cover, CoverPlate, CoverEdge, AdapterEdge }
